<template>
  <div class="w-full font-proxima">
    <div class="overflow-x-auto shadow-sm ring-1 ring-black ring-opacity-5 rounded-sm bg-white">
      <table class="min-w-full divide-y divide-gray-300">
        <thead class="bg-red-50">
          <tr>
            <th v-for="header in HEADERS" :key="header" class="p-2 text-left align-middle text-sm font-bold border border-white text-blue-500 whitespace-nowrap">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="(row, index) in rows" :key="row.id" :class="index % 2 === 0 ? undefined : 'bg-gray-100'">
            <td class="px-3 py-2 text-sm whitespace-nowrap">
              <button type="button" class="text-blue-500 hover:text-blue-600" @click="openApplicant(row.id)">
                {{ generateApplicantId(row.applicantIdPublic) }}
              </button>
            </td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ fullName(row) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ displayEmail(row.emailAddress) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ displayPhone(row.phoneNumber) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ cityState(row) }}</td>
            <td class="px-3 py-2 text-sm text-black whitespace-nowrap">{{ displayDate(row.createdAt) }}</td>
            <td class="px-3 py-2 text-sm text-black text-center whitespace-nowrap">{{ row.openAssistanceRequests ?? 0 }} / {{ row.totalAssistanceRequests ?? 0 }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="mt-1 text-xs text-gray-500">
      Showing {{ rows.length.toLocaleString() }} of {{ (output?.count ?? rows.length).toLocaleString() }} matching applicants
    </p>
  </div>
</template>
<script setup lang="ts">
interface ApplicantRow {
  id: string;
  applicantIdPublic: number;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  city?: string;
  state?: string;
  createdAt?: string;
  totalAssistanceRequests?: number;
  openAssistanceRequests?: number;
}

const props = defineProps<{ part: { output?: { count?: number; applicants?: ApplicantRow[] } } }>();

const HEADERS = ['Applicant ID', 'Name', 'Email', 'Phone', 'City/State', 'Created', 'Open / Total Requests'];

const output = computed(() => props.part.output);
const rows = computed<ApplicantRow[]>(() => output.value?.applicants ?? []);

const fullName = (row: ApplicantRow) => [row.firstName, row.lastName].filter(Boolean).join(' ');
const cityState = (row: ApplicantRow) => [row.city, row.state].filter(Boolean).join(', ');
const displayEmail = (email?: string) => (!email ? 'No Email Address' : checkSaHelpEmail(email, false) || 'No Email Address');
const displayPhone = (phone?: string) => (phone ? (formatPhoneNumber(phone) ?? phone) : '');
const displayDate = (value?: string) => (value ? new Date(value).toLocaleDateString() : '');

// Same navigation as the Applicants list page (pages/applicants/index.vue)
const openApplicant = (id: string) => {
  window.open(`/applicants/${id}/show`, '_blank');
};
</script>
